import React from "react";

function Suggestion({ suggestions, onClick, onStartCourseSelector }) {
	return (
		<>
			<div className="suggestionButtonContainer">
				{/* Mapping over suggestions to create individual buttons */}
				{suggestions.map((suggestion, index) => (
					<button key={index} className="suggestionButton" onClick={() => onClick(suggestion)}>
						{suggestion}
					</button>
				))}
				<button className="suggestionButton suggestionButtonStartCourse" onClick={onStartCourseSelector}>
					Starta kursväljaren
				</button>
			</div>
		</>
	);
}

export default Suggestion;
